import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.911 18.294V12.48H4.777c-.575 0-.964-.562-.684-1.025l5.72-10.07c.357-.66 1.461-.42 1.461.324v5.884h3.948c.575 0 .948.548.7 1.011l-5.534 10c-.373.673-1.477.434-1.477-.31",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }